export default __webpack_public_path__ + "static/media/user-bg-icon.f8347603.svg";